import {
    RaceSessionType,
    RaceSessionStatus,
    RACE_STATUS_PLAYED,
    RACE_STATUS_PLAYING,
    FREE_PRACTICE_ONE,
    FREE_PRACTICE_TWO,
    FREE_PRACTICE_THREE,
    FREE_PRACTICE_FOUR,
    QUALIFYING_ONE,
    QUALIFYING_TWO,
    QUALIFYING_THREE,
    SHOOTOUT_SPRINT_ONE,
    SHOOTOUT_SPRINT_TWO,
    SHOOTOUT_SPRINT_THREE,
    QUALIFYING_SPRINT,
    RACE,
    RACE_ONE,
    RACE_TWO,
    RACE_SPRINT,
    STARTING_GRID,
    STARTING_GRID_SPRINT,
    WARMUP,
} from '../types/race-session';
import { DRIVERS_STANDING_FREE_PRACTICE_RESULTS, DRIVERS_STANDING_QUALIFYING_RESULTS, DRIVERS_STANDING_RACE_RESULTS, DRIVERS_STANDING_RACE_STARTING_GRID } from '../types/race-session';
import { DriversStadingVariants } from '../types/drivers-standings';

const compileRowsStatusArray = [RACE_STATUS_PLAYED, RACE_STATUS_PLAYING];
const raceSessionToDriverStandingMap = {
    [FREE_PRACTICE_ONE]: DRIVERS_STANDING_FREE_PRACTICE_RESULTS,
    [FREE_PRACTICE_TWO]: DRIVERS_STANDING_FREE_PRACTICE_RESULTS,
    [FREE_PRACTICE_THREE]: DRIVERS_STANDING_FREE_PRACTICE_RESULTS,
    [FREE_PRACTICE_FOUR]: DRIVERS_STANDING_FREE_PRACTICE_RESULTS,
    [QUALIFYING_ONE]: DRIVERS_STANDING_QUALIFYING_RESULTS,
    [QUALIFYING_TWO]: DRIVERS_STANDING_QUALIFYING_RESULTS,
    [QUALIFYING_THREE]: DRIVERS_STANDING_QUALIFYING_RESULTS,
    [SHOOTOUT_SPRINT_ONE]: DRIVERS_STANDING_QUALIFYING_RESULTS,
    [SHOOTOUT_SPRINT_TWO]: DRIVERS_STANDING_QUALIFYING_RESULTS,
    [SHOOTOUT_SPRINT_THREE]: DRIVERS_STANDING_QUALIFYING_RESULTS,
    [QUALIFYING_SPRINT]: DRIVERS_STANDING_QUALIFYING_RESULTS,
    [RACE]: DRIVERS_STANDING_RACE_RESULTS,
    [RACE_ONE]: DRIVERS_STANDING_RACE_RESULTS,
    [RACE_TWO]: DRIVERS_STANDING_RACE_RESULTS,
    [RACE_SPRINT]: DRIVERS_STANDING_RACE_RESULTS,
    [STARTING_GRID]: DRIVERS_STANDING_RACE_STARTING_GRID,
    [STARTING_GRID_SPRINT]: DRIVERS_STANDING_RACE_STARTING_GRID,
    [WARMUP]: DRIVERS_STANDING_RACE_STARTING_GRID,
};

const showTimigsStatusArray = [RACE_STATUS_PLAYED];

export const compileSessionRowsForSessionStatus = (sessionStatus: RaceSessionStatus) =>
    compileRowsStatusArray.includes(sessionStatus);

export const getStandingVariantByRaceSession = (raceSession: RaceSessionType): DriversStadingVariants =>
    raceSessionToDriverStandingMap[raceSession];

export const showTimingsForSessionStatus = (sessionStatus: RaceSessionStatus) =>
    showTimigsStatusArray.includes(sessionStatus);